import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createExtraAchievement } from "../api/index.v2";

export const useCreateExtraAchievement = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createExtraAchievement,
    onSuccess: () => {
      queryClient.invalidateQueries(["agentsTargets"]);
      queryClient.invalidateQueries(["extraAchievments"]);
    },
  });
};
